<template>
    <v-container fluid>
        <v-row>
            <v-flex xs4>
                <v-text-field label="Neliöt" v-model="squares">
                </v-text-field>
            </v-flex>
            <v-flex xs4>
                <v-text-field label="Korkeus" v-model="height">
                </v-text-field>
            </v-flex>
            <v-flex xs4>
                <v-select :items="buildingTypes" label="Rakennus" v-model="selectedType" clearable></v-select>
            </v-flex>
            <v-btn @click="laskeRivit">Laske</v-btn>
        </v-row>
        <template v-if="rows.length > 0">
            <v-row>
                <v-flex xs12>Suodatus</v-flex>
                <v-flex xs12>
                    <v-select :items="heatingMethods" label="Lämmitys" v-model="selectedMethod" clearable></v-select>
                </v-flex>
                <v-flex xs12>
                    <v-select :items="areas" label="Alue" v-model="selectedArea" clearable></v-select>
                </v-flex>
            </v-row>
            <v-row>
                <v-data-table :headers="headers" hide-default-footer multi-sort :items="filteredRows"
                              :items-per-page="10000">
                </v-data-table>
            </v-row>
        </template>
    </v-container>
</template>

<script>
  import params from "../params";
  import laskuri from "../laskuri";
  import oljy from "../formulas/oljy";
  import maalampo from "../formulas/maalampo";
  import ilmavesi from "../formulas/ilmavesi";
  import sahko from "../formulas/sahko";
  import kaukolampo from "../formulas/kaukolampo";

  export default {
    data() {
      return {
        squares: 150,
        height: 2.5,
        selectedType: 'okt',
        selectedMethod: null,
        selectedArea: null,
        rows: [],
        headers: [
          {
            text: 'Lämmitys',
            value: 'type',
          },
          {
            text: 'Vuosi',
            value: 'year'
          },
          {
            text: 'Alue',
            value: 'area'
          },
          {
            text: 'kayttoonotto',
            value: 'kayttoonottokustannukset'
          },
          {
            text: 'investointi',
            value: 'investointi'
          },
          {
            text: 'teho',
            value: 'teho'
          },
          {
            text: 'energ kok kust /a',
            value: 'energia_kokonaiskustannukset_vuodessa'
          },
          {
            text: 'Co2',
            value: 'co2_vuodessa'
          },
        ]
      }
    },
    computed: {
      filteredRows() {
        let r = this.rows;
        if (this.buildingTypes.indexOf(this.selectedType) !== -1) {
          r = r.filter(row => row.building === this.selectedType);
        }

        if (this.selectedMethod != null && this.selectedMethod !== '') {
          r = r.filter(row => row.type === this.selectedMethod)
        }
        if (this.selectedArea != null && this.selectedArea !== '') {
          r = r.filter(row => row.area === this.selectedArea)
        }

        return r;
      },
      areas() {
        return params.areas;
      },
      buildingTypes() {
        return params.buildingTypes;
      },
      heatingMethods() {
        return [{ text: 'Kaukolampo', value: 'kaukolampo'}, ...params.heatingMethods, ];
      }
    },
    methods: {
      laskeRivit() {
        const buildings = [
          {
            type: this.selectedType,
            size: Number.parseInt(this.squares),
            height: Number.parseInt(this.height),
          },
        ];

        buildings.forEach(b => {
          params.years.forEach(y => {
            params.areas.forEach(a => {
              const rakennustyyppi = b.type;
              const volume = b.size * b.height;

              const tehonTarve = laskuri.laskeTehonTarve(rakennustyyppi, y.value, volume);
              const energiaKulutus = laskuri.laskeOminaiskulutus(rakennustyyppi, y.value, volume);
              const calculated = this.laske(a.value, rakennustyyppi, tehonTarve, energiaKulutus);

              const c = ['kaukolampo', 'maalampo', 'oljy', 'sahko', 'ilmavesi'];
              c.forEach(m => {
                const fields = calculated[m];
                this.rows.push({
                  year: y.text,
                  building: b.type,
                  area: a.value,
                  type: m,
                  size: b.size,
                  ...fields
                })
              })


            });
          });
        })
      },
      laske(sijainti, rakennustyyppi, teho, energiaKulutus) {
        const alennus = 0;
        const kl = kaukolampo.laske(sijainti, rakennustyyppi, teho, energiaKulutus, alennus);
        const ml = maalampo.laske(sijainti, rakennustyyppi, teho, energiaKulutus);
        const ol = oljy.laske(sijainti, rakennustyyppi, teho, energiaKulutus);
        const sah = sahko.laske(sijainti, rakennustyyppi, teho, energiaKulutus);
        const iv = ilmavesi.laske(sijainti, rakennustyyppi, teho, energiaKulutus);

        return {
          kaukolampo: kl,
          maalampo: ml,
          oljy: ol,
          sahko: sah,
          ilmavesi: iv,
        };

      }
    },

    mounted() {

    },
  }
</script>

<style scoped>

</style>
